interface ArticleJsonLdProps {
  headline: string;
  description: string;
  imageUrl: string;
  datePublished?: string;
  dateModified?: string;
  authorName?: string;
  slug: string;
}

export default function ArticleJsonLd({
  headline,
  description,
  imageUrl,
  datePublished = '2026-06-26',
  dateModified = '2026-06-26',
  authorName = 'hoobuy.website',
  slug,
}: ArticleJsonLdProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline,
    description,
    image: imageUrl,
    datePublished,
    dateModified,
    author: {
      '@type': 'Person',
      name: authorName,
    },
    publisher: {
      '@type': 'Organization',
      name: 'hoobuy.website',
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://hoobuy.website${slug}`,
    },
    inLanguage: 'pt',
    isAccessibleForFree: true,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}